import { SET_NEW_MESSAGE } from '../types/newMessages';

export const setNewMessage = (message) => {
  return {
    type: SET_NEW_MESSAGE,
    payload: message,
  };
};
